// extracted by mini-css-extract-plugin
module.exports = {"box_section":"Box_box_section__B67GS"};